import { FormattedMessage, injectIntl } from 'react-intl';
import React, { useState, useEffect, useContext, useRef, useImperativeHandle } from 'react';
import { Row, Col, Button, Input, Form, message, Select } from 'antd';
import _ from 'lodash';
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
import CvvPopover from '@/components/H5PC/Components/CvvPopover/index.jsx';
import myContext from '@/utils/createContext';
import { gtag } from '@/utils';

const FormItem = Form.Item;
const { Option } = Select;

function ExpiryDateAndCVV(props) {
  const { intl, isDisabledCardExpiryDate, cardTokenType } = props;
  const { formatMessage } = intl;
  const cvvRef = useRef();
  const expiryDateRef = useRef();
  const nameOnCardRef = useRef();

  const { form, isMobileView, showDomain } = useContext(myContext);
  const [beforeVal, setBeforeVal] = useState('');

  const onBlurCardCvv = async function(e) {
    gtag(`${showDomain}支付页面`, [new Date() + '输入安全码']);
    gtag(`${showDomain}支付页面`, ['输入安全码']);
    showDomain ? gtag(`定制支付页面`, ['输入安全码']):'';
  };

  const onBlurCardExpiryDate = async function(e) {
    gtag(`${showDomain}支付页面`, [new Date() + '输入失效日期']);
    gtag(`${showDomain}支付页面`, ['输入失效日期']);
    showDomain ? gtag(`定制支付页面`, ['输入失效日期']):'';
  };

  useImperativeHandle(props.cref, () => ({
    clickEdit
  }));

  const clickEdit = () => {
    setRefChange(cvvRef);
    setRefChange(expiryDateRef);
  };

  // 动态改变label的值
  const setRefChange = cref => {
    if (!_.isEmpty(cref.current)) {
      cref.current.setLabelClass();
    }
  };

  return (
    <div className="h5pc-bank-info">
      <Row gutter={20} className="h5pc-bank-info-yymm-cvv">
        <Col span={12} className="h5pc-bank-info-yymm">
          <FloatLabel
            form={form}
            name="cardExpiryDate"
            cref={expiryDateRef}
            // label="Expiry Date MM/YY"
            label={formatMessage({ id: 'ga-checkout.expiry-date' })}
            rules={[
              {
                required: true,
                // message: `An expiration date is required.`,
                message: formatMessage({
                  id: 'ga-checkout.expiration-required',
                }),
              },
              {
                pattern: new RegExp(
                  `^((0[1-9]|1[012])[-\/.][0-9]?[0-9]?[0-9]{2})*$`,
                  'g',
                ),
                // message: `Update your card's expiration date.`,
                message: formatMessage({
                  id: 'ga-checkout.update-expiration-date',
                }),
              },
              ({ getFieldValue }) => ({
                validator: async (rule, value) => {
                  if (_.isEmpty(value)) return;
                  let newVal = value.replace(/[^0-9]/gi, '');
                  // console.log(2222, newVal);
                  const oldYear = newVal.substr(2, 3);
                  const oldMonth = newVal.substr(0, 2);
                  let curYear = new Date().getFullYear();
                  curYear = curYear.toString().substr(2, 3);
                  let curMonth = new Date().getMonth() + 1;
                  // console.log('curYear', curYear);
                  // console.log('curMonth', curMonth);
                  if (
                    newVal.length === 4 &&
                    oldMonth !== '00' &&
                    parseInt(oldMonth) <= 12
                  ) {
                    if (parseInt(oldYear) > parseInt(curYear)) {
                    } else if (
                      parseInt(oldYear) === parseInt(curYear) &&
                      parseInt(oldMonth) >= parseInt(curMonth)
                    ) {
                    } else {
                      return Promise.reject(
                        // "Update your card's expiration date",
                        formatMessage({
                          id: 'ga-checkout.update-expiration-date',
                        }),
                      );
                      // throw new Error("Update your card's expiration date.");
                    }
                  }
                },
              }),
            ]}
            getValueFromEvent={e => {
              let val = e.target.value;
              // console.log(22, val);
              let newVal = val.replace(/[^0-9]/gi, ''); // 替换字符串中的所有的非数字
              // console.log(11, newVal);
              if (/^\d{1,}$/g.test(newVal)) {
                if (newVal.length === 1 && parseInt(newVal, 10) > 1) {
                  newVal = '0' + newVal + '/';
                } else if (newVal.length === 2) {
                  // 改变之前的值
                  switch (beforeVal.length) {
                    case 1:
                      newVal = newVal + '/';
                      break;
                    case 3:
                      newVal = newVal.substr(0, 2);
                      break;
                  }
                } else if (newVal.length === 3 && newVal.indexOf('/') > -1) {
                  newVal = newVal.substr(0, 2);
                } else if (newVal.length === 3 && newVal.indexOf('/') === -1) {
                  newVal = newVal.substr(0, 2) + '/' + newVal.substr(2, 3);
                } else if (newVal.length === 4 && newVal.indexOf('/') === -1) {
                  newVal = newVal.substr(0, 2) + '/' + newVal.substr(2, 3);
                }
                form.setFieldsValue({ cardExpiryDate: newVal });
                // form.validateFields(['cardExpiryDate']); // 实时验证
                setBeforeVal(form.getFieldValue('cardExpiryDate')); // 塞入最后一次的值

                e.target.value = newVal;
                return e.target.value;
              } else {
                return e.target.value.replace(/\D/g, '');
              }
            }}          
          >
            <Input
              disabled={isDisabledCardExpiryDate}  
              size="large"
              type="tel"
              maxLength={5}
              onBlur={e => onBlurCardExpiryDate(e)}
            />
          </FloatLabel>
        </Col>
        <Col span={12}>
          {/* <div className="h5-cvv-popover">
            <div>
              <img
                className="h5-cvv-popover-img-small"
                src="/static/images/cvv_big@3x.png"
              ></img>
            </div>
          </div> */}

          <myContext.Provider
            value={{
              isMobileView,
            }}
          >
            <CvvPopover></CvvPopover>
          </myContext.Provider>
          <FloatLabel
            form={form}
            name="cardCvv"
            cref={cvvRef}
            label="CVV"
            rules={[
              {
                required: !isDisabledCardExpiryDate,
                // message: `Please enter your Security Code.`,
                message: formatMessage({
                  id: 'ga-checkout.placeholder-correct-security-code',
                }),
              },
              ({ getFieldValue }) => ({
                validator: async (rule, value) => {
                  if (_.isEmpty(value)) return;
                  if (value === '***') return;
                  let newVal = value.replace(/[^0-9]/gi, ''); // 替换字符串中的所有的非数字
                  if (newVal.length < 3) {
                    // return Promise.reject('Update your card’s security code.');
                    return Promise.reject(
                      formatMessage({
                        id: 'ga-checkout.placeholder-correct-security-code-3-4',
                      }),
                    );
                  }
                },
              }),
            ]}
            getValueFromEvent={event => {
              return event.target.value.replace(/\D/g, '');
            }}
          >
            <Input
              disabled={cardTokenType === 'LIANLIAN_TOKEN' ? false : isDisabledCardExpiryDate}
              size="large"
              type="tel"
              maxLength={4}
              onBlur={e => onBlurCardCvv(e)}
            />
          </FloatLabel>
        </Col>
      </Row>
    </div>
  );
}

export default injectIntl(ExpiryDateAndCVV);
